<template>
  <div class="home">
    <Banner></Banner>
    <Notice></Notice>

    <div class="content-bg">
      <MarketCard></MarketCard>
      <AllMarket></AllMarket>
    </div>

    <Experience></Experience>

    <div style="background-color: #F7F9FE">
      <GetStart></GetStart>
    </div>

    <div style="background-color: #F7F9FE">
      <VideoSection></VideoSection>
    </div>

    <!--<div style="background-color: #1E49AC">
      <ThinkOver></ThinkOver>
    </div>-->

    <registerSuccessfulModal :show.sync="registerSuccessfulModalShow"></registerSuccessfulModal>
  </div>
</template>

<script>
import Banner from './Banner.vue';
import Notice from './Notice.vue';
import MarketCard from './MarketCard.vue';
import AllMarket from './AllMarket.vue';
import GetStart from './GetStart.vue';
import Experience from './Experience.vue';
// import Events from './Events.vue';
// import ThinkOver from './ThinkOver.vue';
// import Reward from './Reward';
import registerSuccessfulModal from '../Account/Login/components/registerSuccessfulModal';
import VideoSection from './VideoSection';
import ThinkOver from './ThinkOver'

// Notice, MarketCard, AllMarket, Experience, GetStart, Events, ThinkOver, Reward, registerSuccessfulModal

export default {
  name: 'Home',
  components: { Banner, Notice, MarketCard, AllMarket, Experience, GetStart, registerSuccessfulModal, VideoSection, ThinkOver },
  data() {
    return {
      banners: [],
      registerSuccessfulModalShow: false
    };
  },
  mounted() {
    let firstLogin = window.localStorage.getItem('firstLogin');
    if (!this.isUndefinedOrNullOrEmpty(firstLogin) && firstLogin === 'true') {
      window.localStorage.removeItem('firstLogin');
      this.registerSuccessfulModalShow = true;
    }
  }
};
</script>

<style scoped>
.content-bg {
  background-color: #1a1f33;
}
</style>
